import request from '@/utils/request';

const PATH = '/stay/category';

export const getStayCategoryList = () => request({
  url: PATH,
  method: 'get',
});
